import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/content";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl">
                <i className="ri-water-flash-line"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.brand}
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-300">
              {siteInfo.description}
              <br />
              每日一站，把焦点事件的来龙去脉讲清楚，也把判断留给你自己。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={`mailto:${siteInfo.email}`}
                rel="nofollow"
                className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="发送邮件"
              >
                <i className="ri-mail-line"></i>
              </a>
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 text-background-100">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 text-background-100">
                <i className="ri-weibo-line"></i>
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-base font-semibold text-background-50">
              站内导航
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              {siteInfo.nav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="whitespace-nowrap text-background-300 transition-colors hover:text-primary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-base font-semibold text-background-50">
              内容分类
            </h3>
            <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/events?cat=${cat.id}`}
                    className="whitespace-nowrap text-background-300 transition-colors hover:text-primary-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-background-400">
              内容仅供信息参考与讨论交流，请理性看待网络信息，尊重每一位当事人。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="flex w-full flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-8">
          <p>© {year} {siteInfo.brand} · {siteInfo.slogan}</p>
          <p className="flex items-center gap-2">
            <i className="ri-mail-send-line"></i>
            {siteInfo.email}
          </p>
        </div>
      </div>
    </footer>
  );
}